import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ScrollToTop from "@/components/feature/ScrollToTop";
import PageMeta from "@/components/feature/PageMeta";
import { categories } from "@/mocks/data";

export default function AboutPage() {
  const jsonLdOrg = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "免费91网页",
    url: "https://www.91web.com",
    description:
      "免费91网页为您提供便捷的在线网页服务，无需注册即可免费使用91网页全部功能。",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "400-888-9191",
      contactType: "customer service",
      email: "contact@91web.com",
      availableLanguage: "Chinese",
    },
    address: {
      "@type": "PostalAddress",
      addressLocality: "北京",
      addressRegion: "北京",
      streetAddress: "朝阳区科技园路91号",
      postalCode: "100000",
      addressCountry: "CN",
    },
  };

  const jsonLdPage = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于我们 - 免费91网页",
    description:
      "了解免费91网页的品牌故事、核心团队、用户口碑和联系方式。免费91网页致力于为用户提供高质量的免费在线内容服务。",
    url: "https://www.91web.com/about",
  };

  const jsonLdFaq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "免费91网页是什么？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "免费91网页是一个综合性中文内容门户平台，提供科技、生活、娱乐、教育、健康等多元领域的优质文章，全部内容免费开放，无需注册即可访问。",
        },
      },
      {
        "@type": "Question",
        name: "如何联系免费91网页的客服？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "您可以通过客服电话400-888-9191或发送邮件至contact@91web.com与我们取得联系，我们的客服团队将在工作时间内尽快回复您。",
        },
      },
    ],
  };

  const testimonials = [
    {
      name: "张先生",
      role: "科技爱好者",
      content:
        "免费91网页是我每天必看的网站，科技数码板块的内容非常专业，而且完全免费，真的是良心平台！",
      rating: 5,
    },
    {
      name: "李女士",
      role: "全职妈妈",
      content:
        "生活百科板块对我帮助很大，从收纳技巧到美食烹饪，每篇文章都很实用。推荐给了很多朋友，大家都说好用。",
      rating: 5,
    },
    {
      name: "王同学",
      role: "大学生",
      content:
        "教育学习专栏的考研攻略和学习方法分享很干货，帮我制定了清晰的备考计划。感谢免费91网页！",
      rating: 5,
    },
    {
      name: "赵女士",
      role: "健身教练",
      content:
        "健康养生板块的内容很科学，不是那种网上随处可见的伪科学文章。作为专业人士，我很认可这里的健康科普。",
      rating: 5,
    },
    {
      name: "刘先生",
      role: "游戏玩家",
      content:
        "娱乐休闲的文章写得很有趣，独立游戏推荐的品味一流，让我发现了很多被埋没的好游戏。",
      rating: 5,
    },
    {
      name: "陈女士",
      role: "上班族",
      content:
        "每天通勤路上都会打开免费91网页看几篇文章，内容丰富而且手机端体验很好，已经成为了我的日常习惯。",
      rating: 5,
    },
  ];

  const milestones = [
    { year: "2023", title: "平台创立", desc: "免费91网页正式上线，开启免费内容服务之旅" },
    { year: "2024", title: "内容拓展", desc: "内容板块扩展到五大领域，月活跃用户突破百万" },
    { year: "2025", title: "全面升级", desc: "平台全面优化改版，引入更智能的内容推荐系统" },
  ];

  return (
    <>
      <PageMeta
        title="关于我们 - 免费91网页"
        description="了解免费91网页的品牌故事、核心团队、用户口碑和联系方式。免费91网页致力于为用户提供高质量的免费在线内容服务，涵盖科技、生活、娱乐、教育、健康等多元领域。"
        keywords="免费91网页,91网页免费入口,免费91网页在线访问,关于免费91网页,91网页免费使用"
        canonicalUrl="https://www.91web.com/about"
      />
      <script type="application/ld+json">{JSON.stringify(jsonLdOrg)}</script>
      <script type="application/ld+json">{JSON.stringify(jsonLdPage)}</script>
      <script type="application/ld+json">{JSON.stringify(jsonLdFaq)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <ScrollToTop />

        <Breadcrumb
          items={[{ label: "首页", href: "/" }, { label: "关于我们" }]}
        />

        <main>
          {/* Hero */}
          <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20modern%20office%20environment%20with%20warm%20natural%20lighting%2C%20collaborative%20workspace%2C%20minimal%20design%2C%20professional%20yet%20inviting%20atmosphere%2C%20team%20working%20together&width=1600&height=400&seq=about-hero&orientation=landscape"
              alt="关于免费91网页"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
            <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
              <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">
                关于我们
              </h1>
              <p className="text-white/90 max-w-xl">
                了解免费91网页的品牌故事与使命愿景
              </p>
            </div>
          </section>

          {/* Brand Introduction */}
          <section className="max-w-4xl mx-auto px-4 md:px-6 py-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6 text-center">
              品牌介绍
            </h2>
            <div className="bg-background-100 rounded-lg p-6 md:p-8">
              <p className="text-foreground-700 leading-relaxed mb-4">
                免费91网页成立于2023年，是一个致力于为用户提供高质量、免费在线内容服务的综合性中文门户平台。我们坚信，优质的内容不应该被付费墙所阻挡，每个人都有权利自由地获取知识和资讯。
              </p>
              <p className="text-foreground-700 leading-relaxed mb-4">
                经过两年的发展，免费91网页已经形成了覆盖科技数码、生活百科、娱乐休闲、教育学习和健康养生五大领域的完整内容矩阵。我们的编辑团队由各领域的专业人士组成，每天为用户精心筛选和创作优质文章。
              </p>
              <p className="text-foreground-700 leading-relaxed mb-4">
                我们始终坚持"内容为王、用户至上"的核心理念，在保证内容质量的同时，不断优化用户的阅读体验。无论是PC端还是移动端，免费91网页都能为您提供流畅、舒适的浏览体验。
              </p>
              <p className="text-foreground-700 leading-relaxed">
                截至目前，免费91网页月活跃用户已突破百万，累计发布优质文章超过5000篇，成为了越来越多用户日常上网冲浪的首选平台。
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
              {[
                { num: "100万+", label: "月活跃用户" },
                { num: "5000+", label: "优质文章" },
                { num: "5", label: "内容分类" },
                { num: "99.9%", label: "服务可用率" },
              ].map((stat, i) => (
                <div
                  key={i}
                  className="text-center p-5 rounded-lg bg-background-100"
                >
                  <div className="text-2xl md:text-3xl font-bold text-primary-600 mb-1">
                    {stat.num}
                  </div>
                  <div className="text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </section>

          {/* Milestones */}
          <section className="max-w-4xl mx-auto px-4 md:px-6 py-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-10 text-center">
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-200 -translate-x-1/2 hidden md:block"></div>
              <div className="space-y-8">
                {milestones.map((item, index) => (
                  <div
                    key={index}
                    className={`flex flex-col md:flex-row gap-4 ${
                      index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                    }`}
                  >
                    <div className="flex-1 hidden md:block"></div>
                    <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0 mx-auto md:mx-0 z-10">
                      <div className="w-3 h-3 rounded-full bg-white"></div>
                    </div>
                    <div className="flex-1 bg-background-100 rounded-lg p-5">
                      <div className="text-xs text-primary-600 font-semibold mb-1">
                        {item.year}
                      </div>
                      <h3 className="text-foreground-950 font-semibold mb-2">
                        {item.title}
                      </h3>
                      <p className="text-sm text-foreground-600">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Core Values */}
          <section className="max-w-4xl mx-auto px-4 md:px-6 py-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-10 text-center">
              核心价值观
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {[
                {
                  icon: "ri-shield-check-line",
                  title: "内容为王",
                  desc: "坚持原创与精选并重，每篇文章都经过专业编辑团队审核，确保内容的准确性和可读性。",
                },
                {
                  icon: "ri-user-heart-line",
                  title: "用户至上",
                  desc: "以用户体验为核心，持续优化平台功能和界面设计，让阅读成为一种享受。",
                },
                {
                  icon: "ri-open-arm-line",
                  title: "开放免费",
                  desc: "坚信知识无价但不应有门槛，所有内容完全免费开放，让每个人都能自由获取信息。",
                },
                {
                  icon: "ri-lightbulb-line",
                  title: "创新驱动",
                  desc: "不断探索新技术和新形式，为用户带来更智能、更多元的内容消费体验。",
                },
                {
                  icon: "ri-team-line",
                  title: "协作共赢",
                  desc: "与优质内容创作者紧密合作，构建健康可持续的内容生态体系。",
                },
                {
                  icon: "ri-earth-line",
                  title: "社会责任",
                  desc: "传播科学知识，倡导理性思考，为建设清朗网络空间贡献力量。",
                },
              ].map((value, i) => (
                <div key={i} className="bg-background-100 rounded-lg p-6">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                    <i className={`${value.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-foreground-950 font-semibold mb-2">
                    {value.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {value.desc}
                  </p>
                </div>
              ))}
            </div>
          </section>

          {/* Content Coverage */}
          <section className="max-w-4xl mx-auto px-4 md:px-6 py-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-10 text-center">
              内容覆盖
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <div
                  key={cat.id}
                  className="flex flex-col items-center p-5 rounded-lg bg-background-100 text-center"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <div className="text-foreground-950 font-medium text-sm mb-1">
                    {cat.name}
                  </div>
                  <div className="text-xs text-foreground-500">
                    {cat.articleCount}篇文章
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Testimonials */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3 text-center">
              用户口碑
            </h2>
            <p className="text-foreground-600 text-center mb-10 max-w-xl mx-auto">
              来自真实用户的评价，这是对我们最大的肯定和鼓励
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.map((t, i) => (
                <div key={i} className="bg-background-100 rounded-lg p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, j) => (
                      <i key={j} className="ri-star-fill text-amber-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{t.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-700 font-medium text-sm">
                      {t.name.charAt(0)}
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">
                        {t.name}
                      </div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section className="max-w-4xl mx-auto px-4 md:px-6 py-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-10 text-center">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-2xl"></i>
                </div>
                <h3 className="text-foreground-950 font-semibold mb-2">
                  电子邮箱
                </h3>
                <p className="text-sm text-foreground-600">contact@91web.com</p>
                <p className="text-xs text-foreground-500 mt-1">工作日24小时内回复</p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-phone-line text-2xl"></i>
                </div>
                <h3 className="text-foreground-950 font-semibold mb-2">
                  客服电话
                </h3>
                <p className="text-sm text-foreground-600">400-888-9191</p>
                <p className="text-xs text-foreground-500 mt-1">周一至周五 9:00-18:00</p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-map-pin-line text-2xl"></i>
                </div>
                <h3 className="text-foreground-950 font-semibold mb-2">
                  公司地址
                </h3>
                <p className="text-sm text-foreground-600">北京市朝阳区科技园路91号</p>
                <p className="text-xs text-foreground-500 mt-1">欢迎来访交流</p>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}